import moment from 'moment'
import {RequestState} from "../requestState";
import {AnalyticsRequestType} from "../services/CaseServiceLogService";
import {setTimeToStartOfDay, setTimeToEndOfDay} from '../helpers/date'

export default {
  devMode: false,
  auth: {
    returnUrl: '/'
  },
  isLogged: !!localStorage.getItem('token'),
  account: null,
  fetchInitDataRequestState: RequestState.NotPerformed,
  fetchAllCostCenters: RequestState.NotPerformed,
  fetchAllRegions: RequestState.NotPerformed,
  availableColorSchemes: [
    {
      title: 'Indigo',
      color: '#3e50b4'
    },
    {
      title: 'Blue',
      color: '#1f95f2'
    },
    {
      title: 'Red',
      color: '#f34336'
    },
    {
      title: 'Pink',
      color: '#e81d63'
    },
    {
      title: 'Purple',
      color: '#9c27b0'
    },
    {
      title: 'Cyan',
      color: '#00bcd3'
    },
    {
      title: 'Green',
      color: '#4cae51'
    },
    {
      title: 'Lime',
      color: '#ccdb38'
    },
    {
      title: 'Orange',
      color: '#fe9800'
    },
    {
      title: 'Brown',
      color: '#795548'
    },
    {
      title: 'Grey',
      color: '#9e9e9e'
    }
  ],
  availableColorSchemesByColor: {},
  availableServiceGroups: [],
  availableServices: [],
  availableClients: [],
  servicesByClients: {},
  dashboard: {
    availableOriginTypes: [
      {
        title: 'All',
        value: null
      },
      {
        title: 'LIS',
        value: 'lis'
      },
      {
        title: 'DP',
        value: 'dp'
      }
    ],
    activityByDate: {
      data: {
        labels: [],
        createdByDate: [],
        validatedByDate: []
      },
      inProgress: false,
      filters: {
        fromDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        originType: null
      }
    },
    reportsByDate: {
      data: {
        labels: [],
        validatedByCreationDate: [],
        overduedByCreationDate: []
      },
      inProgress: false,
      filters: {
        fromDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        originType: null
      }
    },
    casesVsMaterials: {
      data: [],
      inProgress: false,
      filters: {
        fromDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD')
      }
    }
  },
  walldash: {
    caseRegistrationStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 20000,
      updateIntervalId: null,
      data: []
    },
    grossingByDoctorsStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 20000,
      updateIntervalId: null,
      data: []
    },
    grossingByLabManagersStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 20000,
      updateIntervalId: null,
      data: []
    },
    glassesMicrotomedStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 20000,
      updateIntervalId: null,
      data: []
    },
    glassesScannedStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 20000,
      updateIntervalId: null,
      data: []
    },
    doctorOwnersStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 60000,
      updateIntervalId: null,
      data: []
    },
    collaboratorsStats: {
      lastUpdate: null,
      dataLoaded: false,
      inProgress: false,
      updateInterval: 60000,
      updateIntervalId: null,
      data: []
    },
    currentScreen: 0,
    screenChangeInterval: 15000,
    screenChangeIntervalId: null
  },
  analytics: {
    type: AnalyticsRequestType.Standard,
    filter: {
      filterMode: 'RequestedAndExecuted',
      title: null,
      events: ['ChangeRequested', 'ChangeExecuted'],
      dateRange: {
        from: setTimeToStartOfDay(moment().subtract(14, 'days')),
        to: setTimeToEndOfDay(moment()),
      },
      clientIds: [],
      serviceIds: [],
      metaFilters: [],
      pagination: {
        page: 1,
        rowsPerPage: 50
      },
    },
    clientFilter: {
      caseAnomalies: [],
      executedPriceOver9000: false
    },
    response: {},
    requestState: RequestState.NotPerformed
  },
  invoices: {
    filter: {
      clientIds: [],
      statuses: ['Draft', 'Checked', 'Charged', 'Paid'],
      pagination: {
        page: 1,
        rowsPerPage: 50
      },
    },
    response: {},
    requestState: RequestState.NotPerformed,
    items: { // cache
      invoiceId: { // key - caseId (example) - data fetched from `/api/invoices-get`
        requestState: RequestState.NotPerformed,
        response: {}
      }
    },
    logsByInvoices: {
      invoiceId: { // key - caseId (example) - data fetched from `/api/invoices`
        filter: {
          from: null, // Date
          to: null, // Date
          pagination: {
            page: 1,
            rowsPerPage: 50
          },
        },
        clientFilter: {
          caseAnomalies: [],
          executedPriceOver9000: false
        },
        requestState: RequestState.NotPerformed,
        response: {}
      }
    }
  },
  caseInfos: {
    caseId: { // key - caseId (example) - data fetched from `/api/cases/get-info`
    }
  },
  caseServiceLogs: {
    caseId: { // key - caseId (example) - data fetched from `/api/case/service-log/by-case`
      requestState: RequestState.NotPerformed,
      response: {}
    }
  },
  availableContractors: [],
  availableContractorMaterials: [],
  metadata: {
    tableAndId: { // key (example)
      requestState: RequestState.NotPerformed,
      response: {}
    }
  },
  availableLaboratories: [],
  availableReactions: [],
  availableStains: [],
  availableSlideService: [],
  allCostCentersMap: {},
  costCenters: [],
  allRegionsMap: {},
  regions: [],
  dpURL: 'http://app.dpathology.ru/',
}



// WEBPACK FOOTER //
// ./src/store/state.js